import { LOAD_INFLUENCERS, LOAD_SINGLE_INFLUENCER, SEARCH, ADD_INFLUENCER, LOAD_ORGANISATION_NAME, CHANGE_TAB } from './constants';

export function loadInfluencers(page) {
  return {
    type: LOAD_INFLUENCERS,
    page,
  };
}

export function loadSingleInfluencer(id) {
  return {
    type: LOAD_SINGLE_INFLUENCER,
    id,
  };
}

export function search(term) {
  return {
    type: SEARCH,
    term,
  };
}

export function addInfluencer(data, details) {
  return {
    type: ADD_INFLUENCER,
    data,
    details,
  };
}

export function loadOrganisationName() {
  return {
    type: LOAD_ORGANISATION_NAME,
  };
}

export function changeTab(tab) {
  return {
    type: CHANGE_TAB,
    tab,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/influencers/actions.js
 **/